import React, { ReactNode } from "react";

type TokenReplacements = Record<string, ReactNode>;

export function replaceTextTokens(
  text: string,
  replacements: TokenReplacements
): ReactNode[] {
  const tokens = Object.keys(replacements);

  if (tokens.length === 0) return [text];

  const pattern = new RegExp(
    `(${tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`
  );

  return text
    .split(pattern)
    .map((part) =>
      replacements[part] !== undefined ? (
        <React.Fragment key={part}>{replacements[part]}</React.Fragment>
      ) : (
        <React.Fragment key={part}>{part}</React.Fragment>
      )
    );
}
